// eslint-disable-next-line import/prefer-default-export
export const testAttributes = {
    MORTGAGE_BLOCK_BUTTON: 'mortgage_block_button',
};

export const defaultAttributes = {
    BUTTON: 'Continue',
};